module.exports = __webpack_public_path__ + "img/fenxiang2.e1f683fe.png";